import {
  Button,
  Form,
  Input,
  List,
  Modal,
  Popconfirm,
  Select,
  Skeleton,
  Tooltip,
  Typography,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import {
  GetDeviceList,
  GetLicenseManagementSoftwares,
  axiosErrorMessages,
  updateEmployeeLicense,
} from "../../../API/api";
import { enqueueSnackbar } from "notistack";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import AddSoftware from "./AddSoftware";
import axios, { AxiosError } from "axios";
import { Backdrop, CircularProgress } from "@mui/material";
interface Software {
  softwareName: string;
  version: string;
}

interface SoftwareId {
  softwareId: string;
  versionId: string;
}

interface Employee {
  employeeId: string;
  employeeAssets: EmployeeAsset[];
}

interface EmployeeAsset {
  deviceTypeId: number;
  assetTagId: string;
  os: number;
  osVersion: number[];
  assetSoftware: AssetSoftware[];
}

interface AssetSoftware {
  softwareId: number;
  versionId: number[];
}

interface LicenseList {
  assetTagId: string;

  designation: string;
  deviceId: number;
  deviceType: string;
  licenseSoftwares: any[];
  otherSoftwares: any[];
  employeeAssetId: number;

  employeeName: string;
}
interface AddEmployeeLicenseVersion {
  closeAddPopup: (data: any) => void;
  editData: LicenseList;
}
const EditEmployeeLicense: React.FC<AddEmployeeLicenseVersion> = ({
  closeAddPopup,
  editData,
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isedit, setIsEdit] = useState<boolean>(false);
  const [deviceList, setDeviceList] = useState([]);
  const [addLicenseForm] = Form.useForm();
  const [softwareList, setSoftwareList] = useState([]);
  const [isAddSoftware, setIsAddSoftware] = useState<boolean>(false);
  const [isOpen, setIsopen] = useState<boolean>(true);
  const [editSoftwareDetails, setEditSoftwareDetails] = useState({});
  const [selectedSoftwareList, setSelectedSoftwareList] = useState<Software[]>(
    editData.licenseSoftwares
  );
  const [editIndex, setEditIndex] = useState<number>();
  const [softwareId, setSoftwareId] = useState<number>(0);
  const [versionId, setVersionId] = useState<number>(0);
  const [selectedSoftwareListId, setSelectedSoftwareListId] = useState<any>([]);
  useEffect(() => {
    GetDeviceTypeList();
    GetOsList();
    setFormData();
  }, []);
  useEffect(() => {
    if (softwareList.length > 0) {
      const data1 = selectedSoftwareList.map((item: any) => {
        const softwareNameDummy: any = softwareList.find(
          (software: any) => software.softwareId === item.softwareId
        );
        if (softwareNameDummy)
          return {
            ...item,
            softwareName: softwareNameDummy.softwareName,
          };
      });
      setSelectedSoftwareList(data1);
    }
  }, [softwareList]);
  const setFormData = () => {
    // Extracting relevant information
    //joining both license and other softwares
    const softwares = [
      ...editData.licenseSoftwares,
      ...(editData.otherSoftwares || []),
    ];
    const transformedArray = softwares.flatMap((software: any) => {
      if (software.softwareVersions.length > 0) {
        return software.softwareVersions.map((version: any) => ({
          softwareId: software.softwareId,
          softwareName: software.softwareName,
          isOs: software.isOs,
          softwareVersions: [version],
        }));
      } else {
        return [software];
      }
    });

    const softwareInfoCollection: any = transformedArray
      .filter((software: any) => software.softwareVersions.length > 0)
      .map((software: any) => {
        const versionNamesString = software.softwareVersions
          .map((version: any) => version.versions)
          .join(", ");
        return {
          softwareName: software.softwareName,
          softwareId: software.softwareId,
          versionNames: versionNamesString,
          isOs: software.isOs,
        };
      });

    const softwareIdCollection = transformedArray
      .filter((software: any) => software.softwareVersions.length > 0)
      .map((software: any) => {
        return {
          softwareId: software.softwareId,
          versionId: software.softwareVersions.map(
            (version: any) => version.versionId
          )[0],
          isOs: software.isOs,
        };
      });

    setSelectedSoftwareListId(softwareIdCollection);
    setSelectedSoftwareList(softwareInfoCollection);

    addLicenseForm.setFieldsValue({
      employee: editData.employeeName,
      device: editData.deviceId,
      assetTagId: editData.assetTagId,
    });
  };
  const onAddNewSoftware = async () => {
    setIsEdit(false);
    setIsAddSoftware(true);
  };
  const GetOsList = async () => {
    try {
      setIsLoading(true);
      const response = await GetLicenseManagementSoftwares();

      setSoftwareList(response.data);
      setIsLoading(false);
    } catch (error: any) {
      let errorMsg;
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        errorMsg = axiosErrorMessages(axiosError);
      } else {
        errorMsg = error.message;
      }
      enqueueSnackbar(errorMsg, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });

      setIsLoading(false);
    }
  };

  const GetDeviceTypeList = async () => {
    try {
      setIsLoading(true);
      const response = await GetDeviceList();
      const newData = response.data.map((device: any, index: number) => ({
        label: device.deviceType,
        value: device.deviceTypeId,
      }));
      setDeviceList(newData);
      setIsLoading(false);
    } catch (error: any) {
      let errorMsg;
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        errorMsg = axiosErrorMessages(axiosError);
      } else {
        errorMsg = error.message;
      }
      enqueueSnackbar(errorMsg, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      setIsLoading(false);
    }
  };

  type FieldType = {
    employee?: string;
    device?: number;
    assetTagId: string;
  };
  const onClosePopup = () => {
    setIsopen(false);
    closeAddPopup(true);
  };

  const onSaveStatusHandler = (formData: any) => {
    if (selectedSoftwareList.length > 0) {
      if (formData.assetTagId.trim()) {
        const updateData = {
          employeeAssetId: editData.employeeAssetId,
          deviceTypeId: formData.device,
          assetTagId: formData.assetTagId,
          assetSoftwareList: selectedSoftwareListId,
        };

        updateEmployeeLicense(updateData)
          .then((response: any) => {
            enqueueSnackbar("Updated Successfully", {
              variant: "success",
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
            });
            onClosePopup();
          })
          .catch((error: any) => {
            if (error.response.data.errors.License[0]) {
              enqueueSnackbar(error.response.data.errors.License[0], {
                variant: "error",
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "right",
                },
              });
            } else {
              let errorMsg;
              if (axios.isAxiosError(error)) {
                const axiosError = error as AxiosError;
                errorMsg = axiosErrorMessages(axiosError);
              } else {
                errorMsg = error.message;
              }
              enqueueSnackbar(errorMsg, {
                variant: "error",
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "right",
                },
              });
            }
          });
      } else
        enqueueSnackbar("Enter Device Asset Tag ID", {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
    } else
      enqueueSnackbar("Select license softwares", {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
  };

  const populateListData = (formData: any) => {
    setIsAddSoftware(false);
    const result: any = getSoftwareAndVersion(formData);
    let editValue: any = undefined;
    if (isedit) {
      editValue = editIndex;
    }
    const newListArray = selectedSoftwareList.filter(
      (_: any, index: number) => index !== editValue
    );
    const newIdListArray = selectedSoftwareListId.filter(
      (_: any, index: number) => index !== editValue
    );
    setSelectedSoftwareList(newListArray);
    setSelectedSoftwareListId(newIdListArray);

    const uniqueArray: Software[] = removeDuplicates([...newListArray, result]);
    setSelectedSoftwareListId(
      removeDuplicateIds([...newIdListArray, formData])
    );

    setSelectedSoftwareList(uniqueArray);
  };
  const removeDuplicateIds = (arr: any) => {
    const uniqueMap = new Map<string, SoftwareId>();
    arr.forEach((software: any) => {
      const key = `${software.softwareId}_${software.versionId}`;
      uniqueMap.set(key, software);
    });
    return Array.from(uniqueMap.values());
  };

  const removeDuplicates = (arr: any) => {
    const uniqueMap = new Map<string, Software>();
    arr.forEach((software: any) => {
      const key = `${software.softwareName}_${software.versionNames}`;
      uniqueMap.set(key, software);
    });
    return Array.from(uniqueMap.values());
  };

  // Function to get software name and version based on softwareId and versionId
  const getSoftwareAndVersion = (formData: {
    softwareId: number;
    versionId: number;
  }) => {
    const software: any = softwareList.find(
      (item: any) => item.softwareId === formData.softwareId
    );
    if (software) {
      const version = software.versions.find(
        (v: any) => v.versionId === formData.versionId
      );
      if (version) {
        return {
          softwareId: software.softwareId,
          softwareName: software.softwareName,
          versionNames: version.version,
          isOs: software.isOs,
        };
      }
    }

    return undefined;
  };
  const handleEditVersion = (rowData: any, index: number) => {
    setEditIndex(index);
    const softwareId: any = softwareList.find(
      (software: any) => software.softwareName === rowData.softwareName
    );
    if (!softwareId) {
      var filteredSoftware: any = softwareList.filter((software: any) =>
        software.versions.some(
          (version: any) => version.version === rowData.versionNames
        )
      )[0];

      setSoftwareId(filteredSoftware.softwareId);
      setVersionId(
        filteredSoftware.versions.find(
          (version: any) => version.version === rowData.versionNames
        ).versionId
      );
    } else {
      setSoftwareId(softwareId.softwareId);
      if (softwareId)
        setVersionId(
          softwareId.versions.find(
            (version: any) => version.version === rowData.versionNames
          ).versionId
        );
    }

    setIsEdit(true);
    setEditSoftwareDetails(rowData);
    setIsAddSoftware(true);
  };
  const removeItem = (rowData: any, indexToRemove: number) => {
    const updatedSoftwareList = selectedSoftwareList.filter(
      (software: any) =>
        !(
          software.softwareName === rowData.softwareName &&
          software.versionNames === rowData.versionNames
        )
    );
    const newArray = selectedSoftwareListId.filter(
      (_: any, index: number) => index !== indexToRemove
    );

    setSelectedSoftwareListId(newArray);

    setSelectedSoftwareList(updatedSoftwareList);
  };
  const onClose = () => setIsAddSoftware(false);

  const filterOption = (
    input: string,
    option?: { label: string; value: number }
  ) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
  return (
    <>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme: any) => theme.zIndex.drawer + 1,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Modal
        maskClosable={false}
        footer={null}
        title="Edit License Provision"
        onCancel={onClosePopup}
        open={isOpen}
      >
        <br />

        <Form
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 12 }}
          style={{ maxWidth: 1000 }}
          onFinish={onSaveStatusHandler}
          autoComplete="off"
          form={addLicenseForm}
        >
          <Form.Item<FieldType>
            rules={[{ required: true, message: "Enter Name" }]}
            name="employee"
          >
            <Input
              className="input-edit"
              style={{ pointerEvents: "none" }}
              bordered={false}
            />
          </Form.Item>
          <Form.Item
            rules={[{ required: true, message: "Enter Name" }]}
            name="device"
          >
            <Select
              showSearch
              style={{ width: "100%" }}
              placeholder="Select Device"
              options={deviceList}
              filterOption={filterOption}
            />
          </Form.Item>
          <Form.Item<FieldType>
            rules={[{ required: true, message: "Enter TagID" }]}
            name="assetTagId"
          >
            <Input className="input-edit" />
          </Form.Item>

          <Button
            type="text"
            onClick={onAddNewSoftware}
            icon={<PlusOutlined />}
          >
            Add Software
          </Button>
          <List
            size="small"
            className="demo-loadmore-list"
            itemLayout="horizontal"
            dataSource={selectedSoftwareList}
            renderItem={(item: any, index) => (
              <List.Item
                actions={[
                  <>
                    <Typography.Link
                      onClick={() => handleEditVersion(item, index)}
                    >
                      {" "}
                      <EditOutlined />
                    </Typography.Link>
                    <Popconfirm
                      title="Do you want to remove the version?"
                      onConfirm={() => removeItem(item, index)}
                    >
                      <a>
                        {" "}
                        <DeleteOutlined />
                      </a>
                    </Popconfirm>
                  </>,
                ]}
              >
                <Skeleton avatar title={false} loading={item.loading} active>
                  {/* <List.Item.Meta title={item.softwareName} />
  
                              <List.Item.Meta title={item.versionNames} /> */}
                  <List.Item.Meta
                    title={
                      <Tooltip placement="topLeft" title={item.softwareName}>
                        {item.softwareName && item.softwareName.length > 20
                          ? `${item.softwareName.slice(0, 20)}...`
                          : item.softwareName}
                      </Tooltip>
                    }
                  />
                  <List.Item.Meta
                    title={
                      <Tooltip placement="topLeft" title={item.versionNames}>
                        {item.versionNames && item.versionNames.length > 20
                          ? `${item.versionNames.slice(0, 20)}...`
                          : item.versionNames}
                      </Tooltip>
                    }
                  />
                </Skeleton>
              </List.Item>
            )}
          />

          <Button className="pm-btn" type="primary" htmlType="submit">
            Save
          </Button>
        </Form>
      </Modal>

      {isAddSoftware && (
        <AddSoftware
          softwareId={softwareId}
          versionId={versionId}
          isEdit={isedit}
          editSoftwareDetails={editSoftwareDetails}
          onClose={onClose}
          populateListData={populateListData}
        />
      )}
    </>
  );
};

export default EditEmployeeLicense;
